import { toast } from '@kalos/ui';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { PermissionsManager } from '../modules/PermissionsManager';
import { permissionsManagerCheck } from '../tools/permissionChecks';

export const Route = createFileRoute('/permissionsManager')({
  component: PermissionsManager,
  loader(ctx) {
    const permissionCheck = permissionsManagerCheck(ctx.context.authContext.user);
    if (!permissionCheck) {
      toast({
        title: 'Access Denied',
        description:
          'You do not have permission to access the Permissions Manager. Please contact your administrator if you believe this is an error.',
        variant: 'destructive',
      });
      throw redirect({ to: '/' });
    }
  },
  head() {
    return {
      meta: [{ title: 'Permissions Manager' }],
    };
  },
});
